import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
import './TS_Checkbox.scss';
/**
 * Checkbox made simple..
 *
 * <b>SCSS:</b>
 * ```scss
 * .ts-checkbox ts-checkbox__checked/ts-checkbox__unchecked ts-checkbox__disabled ts-checkbox__rounded {
 * 	 .ts-checkbox__inner ts-checkbox__checked/ts-checkbox__unchecked ts-checkbox__disabled ts-checkbox__rounded {
 *
 * 	 }
 * }
 * ```
 */
export class TS_Checkbox extends ComponentSync {
    static editable = (templateProps) => {
        return (props) => {
            const checked = props.editable.get(props.prop);
            return _jsx(TS_Checkbox, { ...templateProps, ...props, checked: checked, onCheck: checked => props.editable.updateObj({ [props.prop]: checked }) });
        };
    };
    constructor(p) {
        super(p);
    }
    deriveStateFromProps(nextProps, state) {
        state.checked = nextProps.checked ?? false;
        state.disabled = nextProps.disabled;
        state.className = nextProps.className;
        return state;
    }
    onCheckboxClick = (e) => {
        if (this.state.disabled)
            return;
        this.props.onCheck?.(!this.state.checked, e);
    };
    render() {
        const checkedClass = this.state.checked && 'ts-checkbox__button__checked' || 'ts-checkbox__button__unchecked';
        const disabledClass = this.state.disabled && 'ts-checkbox__button__disabled';
        const roundedClass = this.props.rounded && 'ts-checkbox__button__rounded';
        const className = _className('ts-checkbox__button', disabledClass, checkedClass, roundedClass);
        const innerClassName = _className('ts-checkbox__button__inner', disabledClass, checkedClass, roundedClass);
        return _jsxs("div", { className: _className('ts-checkbox', this.state.className, this.state.disabled && 'ts-checkbox__disabled'), onClick: this.onCheckboxClick, children: [_jsx("div", { id: this.props.id, className: className, children: this.props.icon ? this.props.icon : _jsx("div", { className: innerClassName }) }), this.props.children && _jsx("div", { className: "ts-checkbox__content", children: this.props.children })] });
    }
}
//# sourceMappingURL=TS_Checkbox.js.map